<template>
    <ul class="uk-list">
        <li v-for="variant in variants">
            <label class="uk-flex uk-flex-middle" :for="'variant-'+variant.id">
                <input type="radio" :id="'variant-'+variant.id" name="variant" @change="selectedVariant(variant)" :value="variant.id" v-model="selected">
                <div class="uk-margin-small-left">
                    <div class="uk-flex uk-flex-middle">
                        <div v-if="variant.thumbnail" v-html="variant.thumbnail.thumbnail"></div>
                        <div class="uk-margin-small-left">
                            {{ variant.name }}
                        </div>
                    </div>
                </div>
                <div class="uk-margin-small-left">
                    {{ Utils.Currencies.toHuman(variant.pricing.price) }}
                </div>
            </label>
        </li>
    </ul>
</template>
<script>
  export default {
    props: {
      variants: {
        type: Array,
        required: true,
      },
      value: {
        type: Number,
        default: null,
      }
    },
    data() {
      return {
        selected: this.value,
      };
    },
    methods: {
      selectedVariant(variant) {
        window.App.$emit('variant-changed', variant);
      },
    },
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/taxonomies/assets/js/components/ProductVariantPicker.vue